/**
 * Google Analytics utility functions
 * Tracks user behavior and custom events
 */

/**
 * Track custom events
 * @param {string} eventName - Name of the event
 * @param {object} params - Additional parameters
 */
export const trackEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }
};

/**
 * Track mode switches (Virgo/Taurus)
 */
export const trackModeSwitch = (mode) => {
  trackEvent('mode_switch', {
    event_category: 'engagement',
    event_label: mode,
    mode: mode
  });
};

/**
 * Track query submissions
 */
export const trackQuerySubmit = (mode, creditsUsed = null) => {
  const params = {
    event_category: 'query',
    event_label: `${mode}_query`,
    mode: mode
  };

  if (creditsUsed !== null) {
    params.credits_used = creditsUsed;
  }

  trackEvent('query_submit', params);
};

/**
 * Track feature usage
 */
export const trackFeatureUse = (featureName, details = {}) => {
  trackEvent('feature_use', {
    event_category: 'feature',
    event_label: featureName,
    ...details
  });
};

/**
 * Track errors
 */
export const trackError = (errorType, errorMessage, context = {}) => {
  trackEvent('error', {
    event_category: 'error',
    event_label: errorType,
    error_message: errorMessage,
    ...context
  });
};

/**
 * Track datasource operations
 */
export const trackDatasource = (action, datasourceName) => {
  trackEvent('datasource', {
    event_category: 'datasource',
    event_label: action,
    datasource_name: datasourceName
  });
};

/**
 * Track upgrade/pricing interactions
 */
export const trackUpgrade = (action, tier = null) => {
  const params = {
    event_category: 'upgrade',
    event_label: action
  };

  if (tier) {
    params.tier = tier;
  }

  trackEvent('upgrade_interaction', params);
};

/**
 * Track page views (for SPA navigation)
 */
export const trackPageView = (pagePath) => {
  if (window.gtag) {
    window.gtag('config', 'G-K0TGSXMQML', {
      page_path: pagePath
    });
  }
};
